<app-crear-editar
  [loading]="!form"
  [title]="title"
  [subtitle]="subtitle"
  icono="directions_bus"
>
  @if (form) {
    <form
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
      id="form"
    >
      <div class="form-pasos-layout">
        <app-pasos-nav
          [stepper]="stepper"
          etiqueta="Pasos del colectivo"
        ></app-pasos-nav>

        <mat-stepper #stepper [linear]="false" class="form-pasos-stepper">
          <!-- Identificación y estado -->
          <mat-step
            [stepControl]="form.controls['identificacion']"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>Datos</ng-template>
            <app-content-card title="Datos" icon="directions_bus">
              <section class="inputs-group">
                <div class="form-field-wrapper" style="width: 100%">
                  <mat-form-field class="no-hint" style="width: 100%">
                    <mat-label>Identificación</mat-label>
                    <input
                      matInput
                      formControlName="identificacion"
                      [errorStateMatcher]="chequeo.matcher"
                    />
                    <mat-icon matPrefix>badge</mat-icon>
                  </mat-form-field>
                  <app-mensaje-identificacion
                    [chequeo]="chequeo"
                  ></app-mensaje-identificacion>
                </div>

                <ng-container [formGroup]="vehiculoForm">
                  <ng-select
                    style="width: 100%"
                    formControlName="estado"
                    placeholder="Estado"
                    [items]="estados"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                </ng-container>
              </section>
            </app-content-card>
          </mat-step>

          <!-- Cliente y atención de eventos -->
          @if (!helper.esClienteFinal()) {
            <mat-step
              [stepControl]="form.controls['idCliente']"
              errorMessage="Campos incompletos"
            >
              <ng-template matStepLabel>Cliente y atención</ng-template>
              <app-content-card title="Cliente y atención" icon="business">
                <div class="client-section-wrapper">
                  <div class="client-fields">
                    <section
                      class="inputs-group"
                      style="flex-direction: column"
                    >
                      <app-cliente-selector
                        formControlName="idCliente"
                        placeholder="Cliente propietario"
                        (clienteChange)="onClienteChange($event)"
                        [filterModules]="['moduloColectivos']"
                        [showCrearBtn]="
                          helper.tienePermiso('Administración - Crear clientes')
                        "
                      ></app-cliente-selector>

                      <app-config-horarios-atencion
                        formControlName="configHorariosAtencion"
                        [idClienteFinal]="idCliente"
                      ></app-config-horarios-atencion>

                      <app-config-horarios-atencion
                        formControlName="configHorariosAtencionTecnica"
                        titulo="Clientes que Atienden Servicios Técnicos"
                        [idClienteFinal]="idCliente"
                      ></app-config-horarios-atencion>

                      <div>
                        <mat-checkbox
                          color="primary"
                          formControlName="puedeSolicitarServicioTecnico"
                        >
                          Puede solicitar servicio técnico
                        </mat-checkbox>
                        <small class="ayuda">
                          Permite que el cliente genere solicitudes de servicio
                          técnico desde su app
                        </small>
                      </div>
                    </section>
                  </div>

                  <!-- Gráfico de jerarquía de clientes -->
                  @if (idCliente) {
                    <div class="client-hierarchy">
                      <app-jerarquia-cliente
                        [idCliente]="idCliente"
                      ></app-jerarquia-cliente>
                    </div>
                  }
                </div>
              </app-content-card>
            </mat-step>
          }

          <!-- Tracker, línea y chofer -->
          <mat-step
            [stepControl]="form.controls['idTracker']"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>Asignaciones</ng-template>
            <app-content-card title="Asignaciones" icon="link">
              <section class="inputs-group">
                <!-- Tracker -->
                <div class="campo-con-boton">
                  <ng-select
                    [items]="trackers"
                    bindLabel="nombre"
                    bindValue="_id"
                    formControlName="idTracker"
                    placeholder="Tracker"
                    notFoundText="No hay trackers disponibles"
                    style="flex: 1"
                    appendTo="body"
                  ></ng-select>
                  <app-button
                    [disabled]="!form.value.idCliente"
                    matType="mat-fab"
                    color="primary"
                    icon="add"
                    [tooltip]="'Crear tracker'"
                    (click)="form.value.idCliente ? crearTracker() : null"
                  ></app-button>
                </div>

                <!-- Línea -->
                <app-grupo-selector
                  style="flex: 1; min-width: 0"
                  formControlName="idGrupo"
                  categoria="Línea de colectivo"
                  [idCliente]="form?.value?.idCliente"
                  placeholder="Línea"
                  [showCrearBtn]="
                    helper.tienePermiso('Colectivos - Crear líneas')
                  "
                ></app-grupo-selector>
              </section>

              <!-- Dashcam: independiente del tracker (puede tener los dos) -->
              <section class="inputs-group">
                <div class="campo-con-boton">
                  <ng-select
                    [items]="dashcams"
                    bindLabel="nombre"
                    bindValue="_id"
                    formControlName="idDashcam"
                    placeholder="Dashcam"
                    notFoundText="No hay dashcams disponibles"
                    style="flex: 1"
                    appendTo="body"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.nombre }}
                      @if (item.uniqueId) {
                        <small class="ng-option-client">
                          {{ item.uniqueId }}
                        </small>
                      }
                    </ng-template>
                  </ng-select>
                  @if (helper.tienePermiso('Administración - Crear dashcams')) {
                    <button
                      irxBotonIcono="borde"
                      tamano="campo"
                      tono="primario"
                      type="button"
                      tooltip="Crear dashcam"
                      [disabled]="!form.value.idCliente"
                      (click)="crearDashcam()"
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                  }
                </div>
              </section>

              <section class="inputs-group" [formGroup]="vehiculoForm">
                <!-- Chofer -->
                <app-usuario-selector
                  style="flex: 1; min-width: 0"
                  formControlName="idChofer"
                  [funciones]="['Chofer']"
                  placeholder="Chofer"
                  [showCrearBtn]="
                    helper.tienePermiso('Colectivos - Crear choferes')
                  "
                ></app-usuario-selector>

                <!-- Identificación externa -->
                <mat-form-field style="flex: 1; min-width: 0">
                  <mat-label>Identificación Externa</mat-label>
                  <input matInput formControlName="idExterno" />
                  <mat-icon matPrefix>tag</mat-icon>
                </mat-form-field>
              </section>
            </app-content-card>
          </mat-step>

          <!-- Datos del vehículo -->
          <mat-step optional>
            <ng-template matStepLabel>Información</ng-template>
            <app-content-card
              title="Información"
              icon="info"
              [formGroup]="vehiculoForm"
            >
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Patente</mat-label>
                  <input matInput formControlName="patente" />
                  <mat-icon matPrefix>pin</mat-icon>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Marca</mat-label>
                  <input matInput formControlName="marca" />
                  <mat-icon matPrefix>business</mat-icon>
                </mat-form-field>
              </section>

              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Modelo</mat-label>
                  <input matInput formControlName="modelo" />
                  <mat-icon matPrefix>directions_bus</mat-icon>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Año</mat-label>
                  <input matInput formControlName="anio" type="number" />
                  <mat-icon matPrefix>calendar_today</mat-icon>
                </mat-form-field>
              </section>
            </app-content-card>
          </mat-step>

          <!-- Recorridos (y ubicación al editar) -->
          <mat-step optional>
            <ng-template matStepLabel>Recorridos</ng-template>
            <app-content-card title="Recorridos" icon="route">
              <section class="inputs-group" [formGroup]="vehiculoForm">
                <ng-select
                  [items]="recorridos"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idsRecorridos"
                  placeholder="Recorridos disponibles"
                  notFoundText="No hay recorridos creados"
                  style="flex: 1; min-width: 0"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  appendTo="body"
                  (change)="changeRecorridos()"
                ></ng-select>

                <div class="campo-con-boton">
                  <ng-select
                    [items]="recorridos"
                    bindLabel="nombre"
                    bindValue="_id"
                    formControlName="idRecorrido"
                    placeholder="Recorrido actual"
                    notFoundText="No hay recorridos creados"
                    style="flex: 1"
                    appendTo="body"
                    (change)="changeRecorridos()"
                  ></ng-select>
                  <app-button
                    [disabled]="!form.value.idCliente"
                    matType="mat-fab"
                    color="primary"
                    icon="add"
                    [tooltip]="'Crear recorrido'"
                    (click)="form.value.idCliente ? crearRecorrido() : null"
                  ></app-button>
                </div>
              </section>
            </app-content-card>

            @if (id) {
              <app-content-card title="Ubicación" icon="map">
                <div class="mapa">
                  <app-mapa-facil></app-mapa-facil>
                </div>
              </app-content-card>
            }
          </mat-step>
        </mat-stepper>
      </div>
    </form>
  }

  @if (form && stepper) {
    <ng-container actions>
      <button irxBoton="secundario" type="button" (click)="helper.volver()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      <button
        irxBoton="secundario"
        type="button"
        (click)="stepper.previous()"
        [disabled]="stepper.selectedIndex === 0"
      >
        <mat-icon>chevron_left</mat-icon>
        Anterior
      </button>
      @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
      <!-- Con el formulario válido, Guardar es la acción principal y
           Siguiente pasa a secundario -->
      @if (!ultimo && form.valid) {
        <button irxBoton="secundario" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      } @else if (!ultimo) {
        <button irxBoton="principal" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      }
      <button
        irxBoton="principal"
        type="submit"
        form="form"
        [disabled]="!form.valid || loading"
      >
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </ng-container>
  }
</app-crear-editar>
